"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfTable = void 0;
var table_1 = require("../../../../core/model/tables/main-structures/table");
var rtf_table_properties_1 = require("./properties/rtf-table-properties");
var RtfTable = (function () {
    function RtfTable(parentCell) {
        if (parentCell === void 0) { parentCell = null; }
        this.indent = 0;
        this.properties = new rtf_table_properties_1.RtfTableProperties();
        this.rows = [];
        this.parentCell = parentCell;
    }
    Object.defineProperty(RtfTable.prototype, "nestingLevel", {
        get: function () { return this.getNestedLevel(); },
        enumerable: false,
        configurable: true
    });
    RtfTable.prototype.getNestedLevel = function () {
        var nestingLevel = 1;
        var parentCell = this.parentCell;
        while (parentCell != null) {
            var parentTable = parentCell.row.table;
            parentCell = parentTable.parentCell;
            nestingLevel++;
        }
        return nestingLevel;
    };
    RtfTable.prototype.createTable = function (tblIndex, parentCell, model) {
        var table = new table_1.Table(this.properties.coreProperties, model.tableStyles[this.properties.style]);
        table.index = tblIndex;
        table.nestedLevel = this.nestingLevel - 1;
        table.parentCell = parentCell;
        this.properties.apply(table);
        return table;
    };
    return RtfTable;
}());
exports.RtfTable = RtfTable;
